module.exports = __webpack_public_path__ + "img/default-unchecked.a2ccc94b.png";